import React from "react";
import "./index.css";
import { useNavigate } from "react-router-dom";
import subscribe from "../../assets/images/svg/subscribe.svg";
import bannerJoin from "../../assets/images/svg/bannerJoin.svg";
import cardSubscribe from "../../assets/images/svg/cardSubscribe.svg";
export default function Join() {
  const navigate = useNavigate();

  return (
    <div className="join-container">
      <img
        width={"100%"}
        src={bannerJoin}
        alt="Join Clawz Entertainment Community - Subscribe Now"
      />
      <div className="d-flex justify-content-center">
        <img
          className="ticker-item scrollClawrranty3"
          onClick={() =>
            window.open(
              "https://forms.office.com/pages/responsepage.aspx?id=V_GNLE1xrkacvoyZrxNXvUYowLV_R6JNjytDt9UarBNUQTVRV1BKNjJQREhWTDQ5MkRCUTFWSFVPTy4u&route=shorturl",
              "_blank"
            )
          }
          style={{ marginTop: "-10%", width: "40%", maxWidth: 250 }}
          src={subscribe}
          alt="cardSubscfribe"
        />
      </div>
    </div>
  );
}
